import { Component, OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss']
})

export class FacilitiesComponent extends SeoAwareBaseComponent implements OnInit {
  public reasons: any[] = [];
  translateSubscription: Subscription = new Subscription();
  subscription: Subscription = new Subscription();

  constructor(
    public injector: Injector,
    public translateService: TranslateService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.setTitle('Facilitățile proiectului Romanescu Park Residence');

    this.setMetaDescription(`
      Printre facilitățile proiectului Romanescu Park se numără: locație privilegiată, aproape de centru
      și natură, finisaje de calitate, parcare pentru locatari și vizitatori, spații de joacă pentru copii,
      spații verzi, apropierea de stații de transport în comun.
    `);

    this.reasons = this.getReasons();

    this.subscription.add(this.translateService.onLangChange
      .subscribe(() => this.reasons = this.getReasons())
    );
  }

  getReasons(): any {
    const reasons = [];

    for (let i = 0; i <= 5; i++) {
      const reason = {
        title: '',
        content: '',
        image: {
          url: ''
        }
      };

      this.translateSubscription.add(
        this.translateService.get('lifestyle_items.' + i + '.title')
          .subscribe((translatedString: string) => {
            reason.title = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('lifestyle_items.' + i + '.content')
          .subscribe((translatedString: string) => {
            reason.content = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('lifestyle_items.' + i + '.image.url')
          .subscribe((translatedString: string) => {
            reason.image.url = translatedString;
          })
      );

      reasons.push(reason);
    }

    return reasons;
  }
}



// WEBPACK FOOTER //
// ./src/app/downtown-life/facilities.component.ts